import { useTranslation } from 'react-i18next'
import { Section } from '#app/ui/components/custom/section'
import { SectionHeader } from '#app/ui/components/custom/section-header'
import { H4 } from '#app/ui/components/typography/h4'

type Step = { step: string; title: string; body: string }

export const Process = () => {
	const { t } = useTranslation('home')
	const steps = t('process.steps', { returnObjects: true }) as Step[]

	return (
		<Section className="scroll-mt-24" id="how-i-work">
			<SectionHeader
				eyebrow={t('process.eyebrow')}
				heading={t('process.heading')}
				lead={t('process.lead')}
			/>
			<ol className="mt-fluid-16 grid gap-px overflow-hidden rounded-2xl border border-hairline bg-hairline md:grid-cols-3">
				{steps.map(step => (
					<li key={step.step} className="bg-background p-6 md:p-8">
						<p className="text-xs font-semibold tracking-widest text-accent-dot">
							{step.step}
						</p>
						<H4 className="mt-3 text-base normal-case">{step.title}</H4>
						<p className="mt-2 text-sm leading-relaxed text-muted-600">
							{step.body}
						</p>
					</li>
				))}
			</ol>
		</Section>
	)
}
